import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';
import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import DashboardLayout from '../DashboardLayout';
import CreateSubscription from '../../containers/CreateSubscription';
import { Loader } from '../Loading';
import GenericNotFound from '../GenericNotFound';
import ProductPageDescription from './ProductPageDescription';
import SetCurrentProduct from '../../containers/SetCurrentProduct';
import ExistingLicenceBanner from '../../containers/ExistingLicenceBanner';
import ExistingSubscriptionBanner from './ExistingSubscriptionBanner';
import UserInvitations from '../../containers/UserInvitations';
import AlertBanner from '../../containers/AlertBanner';
import CustomSwitch from '../CustomSwitch';
import { PERIODICITY } from '../../actions/products';
import BackgroundImage from '../../images/background/background-productPage.png';


const styles = theme => ({
  root: {
    backgroundImage:`url(${BackgroundImage})`, 
    backgroundSize: 'cover', 
    height: '100vh',
    flex: 1,
    overflow: 'auto',
  },
  focused: {
  },
  unFocused: {
    color: grey[500],
  },
  center: {
    display: 'flex',
    justifyContent: 'center'
  },
  customButton: {
    marginTop: 8,
    marginBottom: 16,
    marginLeft:56,
    marginRight: 56,
    borderRadius: 24,
    backgroundColor: '#3E82F7',
    boxShadow: 'none',
  },
});


/**
 * Product Page component
 * Displays the product panel (with subscription, licences and invitations)
 * for the selected product, along with the product card
 */

class ProductPage extends Component {

  state = {
    switchOnMonthly: this.props.planTargetPeriodicity === PERIODICITY.MONTHLY ? true : false,
  }

  
  handleSwitchOnPeriod (chosenPeriodicity) {
    if (chosenPeriodicity === PERIODICITY.MONTHLY) {
      this.setState({switchOnMonthly: true});
    } 
    if (chosenPeriodicity === PERIODICITY.YEARLY) {
      this.setState({switchOnMonthly: false});
    }
    this.props.handlePlanTargetPeriodicity(chosenPeriodicity);
  }

  render() {
    const {
      classes,
      user,
      product,
      account,
      notFound,
    } = this.props;

    const {switchOnMonthly} = this.state; 
    
    if (notFound) {
      return (
        <div className={classes.root} >
          <DashboardLayout>
            <GenericNotFound
              message="This product doesn't exist"
            />
          </DashboardLayout>
        </div>
      )
    }

    // current account subscription
    const subscription = (
      product 
      && account 
      && account.subscriptions 
      && account.subscriptions.find( s => s.plan.product.id === product.id )
    ) || null;
    
    const isExistingYearlyPlan = product && (product.plans.filter(plan => plan.periodicity === PERIODICITY.YEARLY).length >= 1);
    const isExistingMonthlyPlan = product && (product.plans.filter(plan => plan.periodicity === PERIODICITY.MONTHLY).length >= 1);
    const isBothPeriodicityAvailable = isExistingMonthlyPlan && isExistingYearlyPlan;

    return (
      <div className={classes.root} >
        <DashboardLayout 
          title={product && product.name}
          banner={
            <Fragment>
              {
                user.alerts 
                && user.alerts.map(alert => <AlertBanner key={alert.id} alert={alert} user={user} />)
              }
              <UserInvitations productId={product && product.id} />
              {
                subscription
                && <ExistingSubscriptionBanner subscription={subscription} />
              }
              {
                product && product.id && account && account.id
                && <ExistingLicenceBanner 
                      productId={product.id} 
                      userId={account.id} 
                    />
              }
            </Fragment>         
          }
        >
          {
            product 
            && <SetCurrentProduct product={product} />
          }
          {
            product 
            && <ProductPageDescription product={product} />
          }
          <div>  
            {product && account
              ? <CreateSubscription
                  account={account}
                  product={product}
                  disabled={!!subscription}
                  isBothPeriodicityAvailable={isBothPeriodicityAvailable}
                />
              : <Loader /> 
            }
          </div>  
          {isBothPeriodicityAvailable &&
            <div style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}} >
              <Typography variant="button" className={switchOnMonthly ? classes.focus : classes.unFocused}>
                <FormattedMessage id='product.switcher.monthly.text'/>
              </Typography>
                <CustomSwitch
                  checked={!switchOnMonthly}
                  onChange={switchOnMonthly ? () => this.handleSwitchOnPeriod(PERIODICITY.YEARLY) : () => this.handleSwitchOnPeriod(PERIODICITY.MONTHLY)} 
                  value="MonthlyYearlySwitcher"
                  inputProps={{ 'aria-label': 'MonthlyYearlySwitcher' }}
                />
              <Typography variant="button" className={switchOnMonthly ? classes.unFocused : classes.focus}> 
                <FormattedMessage id='product.switcher.yearly.text'/>
              </Typography>
            </div>
          }
        </DashboardLayout>
      </div>
    );
  }

  componentWillMount() {
    const {
      loadData,
    } = this.props;
    loadData();
  }
}

export default withStyles(styles) (ProductPage);

ProductPage.propTypes = {
  user: PropTypes.object.isRequired,
  product: PropTypes.object,
  account: PropTypes.object,
}


// WEBPACK FOOTER //
// ./src/components/products/ProductPage.js